import {
  generatePuzzle as engineGenerate,
  type GenerateOptions,
} from '@org/nonogram-engine';
import type { Difficulty, DensityPreset, PuzzleData, TrainSeed } from './types';

export const DENSITY_MAP: Record<DensityPreset, number> = {
  sparse: 0.3,
  normal: 0.47,
  dense: 0.62,
};

export const TRAIN_GENERATION_POLICY = Object.freeze({
  constructive: true,
}) satisfies Readonly<
  Pick<GenerateOptions, 'constructive'>
>;

export function buildTrainGenerationOptions(
  size: number,
  seed: TrainSeed,
  densityPreset: DensityPreset = 'normal'
): GenerateOptions {
  return {
    rows: size,
    cols: size,
    density: DENSITY_MAP[densityPreset],
    seed,
    ...TRAIN_GENERATION_POLICY,
  };
}

export function generatePuzzle(
  size: number,
  seed: TrainSeed,
  densityPreset: DensityPreset = 'normal'
): PuzzleData {
  const result = engineGenerate(
    buildTrainGenerationOptions(size, seed, densityPreset)
  );

  const difficulty: Difficulty = size <= 5 ? 20 : size <= 10 ? 50 : 80;

  return {
    width: size,
    height: size,
    difficulty,
    solution: result.solution,
  };
}
